import { RefObject, useEffect } from 'react'

export default function useOutsideAlerter({
    elementRef,
    callback,
    excludeCallbackRefs = [],
}: {
    elementRef: RefObject<HTMLElement>
    callback?: () => void
    excludeCallbackRefs?: Array<RefObject<HTMLElement>>
}) {
    const handleClickOutside = (event: MouseEvent) => {
        if (
            callback &&
            elementRef.current &&
            event.target &&
            !elementRef.current.contains(event!.target as Node) &&
            !excludeCallbackRefs.some(
                ref => ref.current!.isEqualNode(event!.target as Node) || ref.current!.contains(event!.target as Node)
            )
        ) {
            callback()
        }
    }

    useEffect(() => {
        if (callback) {
            document.addEventListener('mousedown', handleClickOutside)

            return () => {
                document.removeEventListener('mousedown', handleClickOutside)
            }
        }

        return () => null
    }, [elementRef])
}
